module.exports = __webpack_public_path__ + "static/media/SVGForbes.e18fc5b2.webp";